import React from "react";

const Logo = ({color, width}) => {

  

  let mainColor = '';

  if(color === 'light'){
      mainColor = 'white';
    } else if(color === 'dark'){
      mainColor = 'slate-600';
    } else {
      mainColor = 'gray-300';
    }
  
  const textColor = `text-`+mainColor || `text-white`;
    const borderColor = `border-`+mainColor || `border-white`;  


  return (
    <div id="brand-logo" className="fixed top-0 left-0  flex flex-row m-2 p-1 rounded-md">
            
            <div id="brand-art" className="">
              
              
              <svg  viewBox="263.314 65.829 621.714 888.686" className="icon w-11 h-11" xmlns="http://www.w3.org/2000/svg">
                <path d="M508.343 844.8c198.948-53.394 200.411-52.663 200.411-52.663s5.12 82.652-68.023 106.057l-207.725 56.32s-11.703-81.188 75.337-109.714M701.44 672.183c29.989-13.166 61.44-36.572 94.354-70.949 68.755-72.411 89.235-132.388 89.235-235.52 0-165.303-138.972-299.885-310.858-299.885S263.314 200.41 263.314 365.714c0 111.177 45.349 211.383 160.183 282.332l-21.211-36.572c0 10.972-.732 20.48-2.926 36.572-3.657 33.645-4.389 40.96-2.194 57.051 4.388 27.063 19.748 49.006 46.811 62.172l20.48-39.498-27.063 35.109c15.36 10.971 32.183 12.434 51.2 10.24 10.24-1.463 21.212-3.657 35.109-7.314 2.926-.732 6.583-1.463 10.24-2.926 2.194-.731 10.24-2.926 11.703-3.657 3.657-1.463 6.583-2.194 9.508-2.926 2.195-.731 4.389-1.463 5.852-1.463h-2.195v-87.771c-8.777 0-16.091 1.463-27.062 4.388-3.658.732-6.583 2.195-11.703 2.926-1.463.732-9.509 2.926-11.703 3.657q-5.486 1.097-8.777 2.195c-9.509 2.194-16.092 4.388-21.212 4.388 2.926.732 7.315 2.194 13.166 5.852l-2.926-2.195-3.657-1.463s2.194 2.926 2.194 3.658c-.731-5.12 0-10.972 2.195-34.378 2.194-19.017 2.925-31.451 2.925-46.08v-24.137L471.04 572.71c-85.577-52.663-118.491-125.075-118.491-208.458 0-117.028 98.742-212.114 220.16-212.114s220.16 95.086 220.16 212.114c0 82.652-13.166 120.686-65.098 176.275-24.868 26.331-47.542 42.423-65.828 51.2q-7.68 3.291-13.166 4.388c1.463 0 1.463 87.772 1.463 87.772 13.166 1.463 30.72-2.195 51.2-11.703" fill="#76BC43"/>
                <path d="m650.971 599.771 95.086-36.571v128c0 26.331-21.211 47.543-47.543 47.543h-47.543z" fill="#76BC43"/>
                <path d="M574.171 541.257S709.486 458.606 709.486 384 648.777 248.686 574.17 248.686 438.857 309.394 438.857 384s135.314 157.257 135.314 157.257" fill="#e9fff9"/>
                <path d="M574.171 541.257s43.886-27.063 81.92-63.634C486.4 292.57 645.851 468.846 480.55 286.72c-25.6 24.869-41.692 59.246-41.692 97.28 0 74.606 135.314 157.257 135.314 157.257" fill="#9ed8db"/>
                <path d="M574.171 541.257s45.349-27.794 83.383-65.097c27.795-27.794 51.932-60.709 51.932-92.16 0-40.96-12.435-92.16-43.886-97.28-81.189 97.28 0 2.926-88.503 107.52-2.926 154.331-2.926 147.017-2.926 147.017" fill="#467599"/>
              </svg>

              
                
              
              
             
            </div>
            <div id="brand-text" className="flex flex-col -mt-1">
              <div id="brand-name" className="flex flex-row">
                
                <h1 className={`${textColor} justify-end right font-bolder border-b border-opacity-20 ${borderColor} -mt-4`}>
                  <span className={`text-base font-light ${textColor}  content-center`}>Smart</span>
                  
                  <span className="text-base font-semibold">Control</span>
                  <sup className={`text-[8px] font-extralight ${textColor}`}>®</sup> 
                </h1>
              </div>
              <sup id="brand-slogan" 
                className={`-z-5 justify-start ${textColor}  text-[8.5px]  font-extralight    text-nowrap`}>
                Hygiene Management App™
              </sup>
            </div>
            
          
    </div>
  );
};

export default Logo;
